import { nanoid } from 'nanoid';

function useUuid(defaultId?: string): string {
  return defaultId ?? nanoid();
}

export default useUuid;
